import React, { useRef, useEffect, MutableRefObject } from 'react'
import LiveLoading from 'live/components/ui/Loading'
import styled from 'styled-components'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { changeValvesColor, setViewBoxOnSvg } from '../utils/utils'

export const WidgetCSBImpl = (
    props: LiveReactChartProps<PropsWidgetCSBState, FlowMessage<ValveEvent>, DefaultChartConfigs>
) => {
    const valves = props.state?.valves
    const { widget } = props
    const svgString = widget?.jsonConfig?.svgString
    const containerRef: MutableRefObject<HTMLDivElement | undefined> = useRef()
    useEffect(() => {
        changeValvesColor(containerRef, valves)
    }, [valves])
    useEffect(() => {
        setViewBoxOnSvg(containerRef)
    }, [containerRef])
    if (!svgString) return <LiveLoading show size="sm" />
    return <StyledDiv ref={containerRef} dangerouslySetInnerHTML={{ __html: svgString }}></StyledDiv>
}

const getInitialValue = () => {
    return { valves: [] }
}

type ValveEvent = LiveEvent<Valve>

type Valve = {
    id: string,
    color: string
}
type PropsWidgetCSBState = {
    valves?: Valve[]
}

const WidgetReducer: WidgetReducerType<PropsWidgetCSBState, FlowMessage<ValveEvent>> = (
    state: PropsWidgetCSBState = getInitialValue(),
    message
): PropsWidgetCSBState => ({ event: { valves: message?.events } }[message?.type] || state)

export default reactWidgetWrapper(WidgetCSBImpl, WidgetReducer)

export const widgetType = 'csb-chart'

export const CONFIG = {
    svgString: null,
    file: null,
    eventType: null,
    manualQuery: null
}

const StyledDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    > svg {
        height: 100%;
        width: 100% !important;
    }
    width: 100% !important;
    height: 100% !important;
`
